import { useMutation } from "@tanstack/react-query";
import { ifsApi } from "lib/axios";

export interface SendEmailPayload {
  to: string[];
  subject: string;
  html: string;
}

// ─── Mutations ───

async function sendEmail({ to, subject, html }: SendEmailPayload): Promise<void> {
  await ifsApi.post("/send-email", { to, subject, html });
}

// Payload shape varies by channel (WhatsApp vs driver-id message); see fuel-plan send flows.
async function sendMessage(config: Record<string, unknown>): Promise<void> {
  await ifsApi.post("/send-message", config);
}

export function useSendEmail() {
  return useMutation({ mutationFn: sendEmail });
}

export function useSendMessage() {
  return useMutation({ mutationFn: sendMessage });
}
